import HtmlContent from '../../components/common/HtmlContent.jsx';
import LoadingState from '../../components/common/LoadingState.jsx';
import PageHero from '../../components/common/PageHero.jsx';
import Seo, { seoText } from '../../components/common/Seo.jsx';
import { useContent } from '../../hooks/useContent.js';

export default function FaqPage() {
  const { content, status } = useContent();
  if (status === 'loading') return <LoadingState label="Loading FAQ" />;

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: content.faq.items.map((item) => ({
      '@type': 'Question',
      name: item.title,
      acceptedAnswer: { '@type': 'Answer', text: seoText(item.content, 1000) },
    })),
  };

  return (
    <>
      <Seo
        title="FAQ"
        description="Answers about ordering, shipping, returns, and La Bella Trading's raw honey, bee products, olive oil, and natural soaps."
        path="/faq"
        jsonLd={faqJsonLd}
      />
      <PageHero
        eyebrow="Help"
        title={content.faq.title}
        text="Everything you need to know about ordering, shipping, and our products."
        image={content.faq.banner || 'assets/uploads/faq-banner.jpg'}
      />
      <section className="container page-section narrow">
        <div className="faq-list">
          {content.faq.items.map((item) => (
            <details key={item.id}>
              <summary>{item.title}</summary>
              <HtmlContent className="rich-text" html={item.content} />
            </details>
          ))}
        </div>
      </section>
    </>
  );
}
